<template>
       <div  v-bind = "{...$attrs}" >
                <div class="topFlex" style="margin-bottom: 10px;padding-right: 0">
                  <el-checkbox v-model="checked">显示全部表头</el-checkbox>
                  <span class="shouqi" @click="shouqi()">展开全部</span>
                </div>
								<div class="tableCon"  :style="{'height':tableHeight}" style="overflow: auto;width: 100%;">
															<vxe-table
																border
																resizable
																auto-resize
																show-footer
																width="100%"
																:data="tableData1">
																<vxe-table-column type="seq"  title="序号"></vxe-table-column>
																<vxe-table-column field="name" title="Excel表头字段" sortable>
									
																</vxe-table-column>
																<vxe-table-column field="name1" title="系统字段" sortable>
																	<template v-slot="{ row }">
																		<el-select >
																			<el-option label="区域一" value="shanghai"></el-option>
																			<el-option label="区域二" value="beijing"></el-option>
																		</el-select>
																	</template>
																</vxe-table-column>
															</vxe-table>
								</div>
               
                <div class="footer">
                  <div>温馨提示：</div>
                  <div>
                    <p>1.当Excel导入的信息项目与系统薪资</p>
                    <p>2.未匹配的薪资项下的数据将不予导入</p>
                    <p>2.系统自动记录对应关系，如导入模板未发</p>
                  </div>
                </div>
                  <div style="margin-top: 8px;padding-bottom: 24px;text-align:center;">
                    <el-button type="primary" @click="next()">下一步</el-button>
                  </div>
              </div>
      
</template>

<script>
  export default {
    name: "step2",
    props: {
       step: {
       	type: String,
       	default: '',
       }
    },
    data() {
      return {
				checked:false,
					tableHeight:'300px',
         tableData:[{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         }],
      };
    },
		computed:{
			tableData1(){
				if(!this.checked){
				 return	this.tableData.slice(0,9);
				}else{
					return	this.tableData.concat([{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         },{
         	name:'员工姓名'
         }])
				}
			}
		},
    methods: {
			shouqi(){
				this.tableHeight = 'auto';
			},
			next(){
				this.$emit('update:step', 'step3')
			}
    }
  };
</script>

<style scoped >
   .topFlex .shouqi{
   	font-size:13px;
   	font-family:PingFangSC-Medium,PingFang SC;
   	font-weight:500;
   	color:rgba(114,181,225,1);
		cursor: pointer;
   }
	 .topFlex{
	 	display: flex;
	 	justify-content: space-between;
	 	background: #fff;
	 	padding: 18px 90px 18px 20px
	 }
	 .footer{
	 	display: flex;
	 	margin-top: 16px;
	 }
	 .footer div{
	 	font-size:13px;
	 	font-family:PingFangSC-Medium,PingFang SC;
	 	font-weight:500;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
	 }
	 .footer p{
	 	font-size:13px;
	 	font-family:PingFangSC-Regular,PingFang SC;
	 	font-weight:400;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
	 	margin-bottom: 8px;
	 }
</style>
